import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_GetBanks } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';
import { useQueryPositionStore } from '~/store/queryPositionStore';
import { queryKeys } from '~/utils/queryKeys';

export function useBanks() {
    const queryPosition = useQueryPositionStore((state) => state.positions[JSON.stringify(queryKeys.getBanks())]);
    return useAggregateQuery({
        acl: {},
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getBanks,
        schema: schemaLoanRequestResolver_GetBanks,
        searchParams: {
            position: queryPosition,
        },
    });
}
